import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchFloor, renting, unRent, unRentList } from '@/api/PMS/baseInformation/house';
import { fetchListByType } from '@/api/PMS/dic/dic';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: ['routerIdArr', 'keyValue', 'showDialog'],
  data: function data() {
    var checkOrder = function checkOrder(rule, value, callback) {
      setTimeout(function () {
        if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入数字值'));
        } else {
          callback();
        }
      }, 100);
    };

    return {
      ruleForm: {
        upIdList: '',
        houseOrder: '',
        floorNumber: '',
        houseCode: '',
        roomNum: '',
        houseType: '',
        houseUseArea: '',
        houseStatus: '',
        listLoading: false
      },
      isClick: true,
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      buildingId: '',
      isDisabled: false,
      floorOption: [],
      typeOption: [],
      stateOption: [],
      checked: '',
      options: [],
      isChecked: false,
      areaId: '',
      childData: {
        upIdList: []
      },
      cascaderItem: [],
      list: [],
      rentingId: [],
      personId: ''
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.options = [];
        this.$refs.dataForm.resetFields();
        this.init();
      }
    },
    buildingId: function buildingId(n) {
      if (n) {
        this.loadFloorOptions(n);
      }
    },
    list: function list(n, o) {
      if (n) {
        this.init();
        console.log(n, 'nn');
      }
    }
  },
  created: function created() {
    this.list = [];
    this.init();
  },
  methods: {
    init: function init() {
      console.log('routerIdArr-house', this.routerIdArr);
      this.isDisabled = false;
      this.isChecked = false;
      this.typeOption = [];
      this.stateOption = [];
      this.options = [];
      this.loadMenuTree();
      this.loadRoomType();
      this.loadRoomState();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      if (val.length > 0) {
        this.isClick = false;
      } else {
        this.isClick = true;
      }

      console.log('5555', val);
      console.log('555555', this.isClick);
      this.rentingId = val;
      this.initSearch = false;
      this.multipleSelection = val;
    },
    handleRent: function handleRent(val) {
      this.childData.houseIsRentable = val === true ? 1 : 0;
    },
    loadMenuTree: function loadMenuTree() {
      var _this = this;

      var treeQuery = {
        flag: 7
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this.options = response.data.data;
      });
    },
    loadRoomType: function loadRoomType() {
      var _this2 = this;

      fetchListByType('house_type').then(function (r) {
        _this2.typeOption = r.data.data;
      });
    },
    loadRoomState: function loadRoomState() {
      var _this3 = this;

      fetchListByType('house_status').then(function (r) {
        _this3.stateOption = r.data.data;
      });
    },
    loadFloorOptions: function loadFloorOptions(val) {
      var _this4 = this;

      var queryList = {
        buildingId: val
      };
      fetchFloor(queryList).then(function (r) {
        _this4.floorOption = r.data.data;
      });
    },
    getBuildingId: function getBuildingId(val) {
      var _this5 = this;

      console.log(val, 'val');
      var query = {};
      query.houseId = this.childData.upIdList[this.childData.upIdList.length - 1];
      this.personId = query.houseId;
      query.isRent = 1;
      query.customerType = 1;
      query.flag = 1;
      query.lvZhlx = '12';
      unRentList(query).then(function (r) {
        console.log('列表接口', r.data.data);
        _this5.list = r.data.data;
      });
    },
    handleUpdate: function handleUpdate() {
      var _this6 = this;

      console.log(this.rentingId, 'rentign');
      var houseIds = [];
      var personIds = [];
      this.rentingId.forEach(function (item) {
        houseIds.push(item.customerId);
        personIds.push(_this6.personId); // console.log(item,'item');
      });

      if (houseIds.length > 0) {
        this.$confirm("你确定是要办理退租, 是否继续?", "提示").then(function () {
          unRent({
            ids: houseIds,
            houseIds: personIds
          }).then(function (res) {
            if (res.data.code === 200) {
              _this6.getBuildingId();

              _this6.$emit("refreshTree");

              _this6.$emit("loadMenuTab");

              _this6.Alert({
                alertType: "add",
                message: '办理退租成功'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    delete: function _delete(houseIds) {
      var _this7 = this;

      if (houseIds.length > 0) {
        this.$confirm("你确定是要删除这些房屋信息, 是否继续?", "提示").then(function () {
          fetchDelete(houseIds).then(function (res) {
            if (res.data.code === 200) {
              _this7.getList();

              _this7.$emit("refreshTree");

              _this7.$emit("loadMenuTab");

              _this7.Alert({
                alertType: "delete"
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(houseId) {
      var houseIds = [];
      houseIds.push(houseId);
      this.delete(houseIds);
    },
    // 获取级联选择器的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this8 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this8.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    handCreate: function handCreate() {
      var _this9 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this9.childData.houseOrder == null || _this9.childData.houseOrder == '') {
            _this9.childData.houseOrder = 0;
          }

          _this9.childData.unintId = _this9.childData.upIdList[_this9.childData.upIdList.length - 1];

          if (_this9.keyValue > 0) {
            delete _this9.childData.areaGroupId;
            delete _this9.childData.areaGroupName;
            delete _this9.childData.areaName;
            delete _this9.childData.buildingName;
            delete _this9.childData.unintName;
            delete _this9.childData.areaId;
            delete _this9.childData.upIdList;
            delete _this9.childData.upAreaId;
            delete _this9.childData.houseIsRentableName;
            delete _this9.childData.houseStatusName;
            delete _this9.childData.houseTypeName;
            delete _this9.childData.floorName;
            delete _this9.childData.opDate;
            fetchUpdate(_this9.childData).then(function () {
              _this9.$emit('handCancle', true);

              _this9.Alert({
                alertType: 'update'
              });
            });
          } else {
            if (_this9.cascaderItem[_this9.cascaderItem.length - 1].flag !== '21') {
              _this9.$message({
                message: '上级机构请选择楼栋单元',
                type: 'error',
                duration: 3000
              });

              return false;
            }

            fetchCreate(_this9.childData).then(function () {
              _this9.$emit('handCancle', true);

              _this9.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this9.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.list = [];
      this.$emit('handCancle', 'renting');
    }
  }
};